// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"818ccbdb","239":"ce2a46e5","732":"ac9eaefc"}[chunkId] + ".chunk.js";
};